// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__IRCky","underline":"Tab_underline__UKltR","selected":"Tab_selected__Bq1db","pills":"Tab_pills__5IGDW","segmented":"Tab_segmented__lfkXN"};